<template>
    <div>
        <div>
            {{
                $t(
                    "Learn the easiest ways to invite people to join the platform and maximize your earnings!"
                )
            }}
        </div>

        <b-tabs class="mt-3" fill>
            <b-tab :title="$t('Creators')" active>
                <div class="pt-3">
                    <div class="mb-3">
                        <strong>{{ $t("How it works") }}</strong>
                        <div class="small text-secondary">
                            {{
                                $t(
                                    "Invite your friends to become creators on Findmate. When they earn, you earn — automatically."
                                )
                            }}
                        </div>
                    </div>
                    <div class="mb-3">
                        <strong>
                            <font-awesome-icon
                                icon="fa-duotone fa-coins"
                                class="mr-1 text-warning"
                            />
                            {{ $t("You earn 10% of their withdrawals") }}
                        </strong>
                        <div class="small text-secondary">
                            {{
                                $t(
                                    "When a creator you invited withdraws, 10% of their withdrawal goes straight to your wallet. So the more they earn, the more you earn."
                                )
                            }}
                        </div>
                    </div>
                    <div class="mb-3">
                        <strong>
                            <font-awesome-icon
                                icon="fa-duotone fa-graduation-cap"
                                class="mr-1 branded"
                            />
                            {{ $t("Help them succeed") }}
                        </strong>
                        <div class="small text-secondary">
                            {{
                                $t(
                                    "The better your friends do, the more you earn. Show them how the app works and help them get started."
                                )
                            }}
                        </div>
                    </div>
                    <div class="mb-3">
                        <strong>
                            <font-awesome-icon
                                icon="fa-duotone fa-sitemap"
                                class="mr-1 branded"
                            />
                            {{ $t("Your network keeps earning") }}
                        </strong>
                        <div class="small text-secondary">
                            {{
                                $t(
                                    "When your friends invite their own friends, you earn from those creators too. Teach your friends to invite — every new person in the network adds to what you make."
                                )
                            }}
                        </div>
                    </div>
                    <div class="mb-3">
                        <strong>
                            <font-awesome-icon
                                icon="fa-duotone fa-piggy-bank"
                                class="mr-1 text-warning"
                            />
                            {{ $t("Skip the jackpot tax") }}
                        </strong>
                        <div class="small text-secondary">
                            {{
                                $t(
                                    "Every withdrawal has a 5% jackpot contribution. Invite 5 friends who earn a reward and yours drops to 0% — you keep more of every payout."
                                )
                            }}
                        </div>
                    </div>
                    <div>
                        <strong>
                            <font-awesome-icon
                                icon="fa-duotone fa-lightbulb"
                                class="mr-1 text-warning"
                            />
                            {{ $t("Tip") }}
                        </strong>
                        <div class="small text-secondary">
                            {{
                                $t(
                                    "Want to see what's possible? Check the leaderboard to see what the top creators and top inviters are making this week."
                                )
                            }}
                        </div>
                    </div>
                </div>
            </b-tab>

            <b-tab :title="$t('Customers')">
                <div class="pt-3">
                    <div class="mb-3">
                        <strong>{{ $t("How it works") }}</strong>
                        <div class="small text-secondary">
                            {{
                                $t(
                                    "When a customer signs up using your invite link and buys credits, you earn a commission on every purchase they make. The more customers you bring in, the more you earn — automatically, every time they pay."
                                )
                            }}
                        </div>
                    </div>
                    <div class="mb-3">
                        <strong>
                            <font-awesome-icon
                                icon="fa-duotone fa-message-lines"
                                class="mr-1 branded"
                            />
                            {{ $t("Step 1 — Make a connection") }}
                        </strong>
                        <div class="small text-secondary">
                            {{
                                $t(
                                    "Start by chatting with people on other apps. Get to know them a little. Build some interest first — don't send your link right away."
                                )
                            }}
                        </div>
                    </div>
                    <div class="mb-3">
                        <strong>
                            <font-awesome-icon
                                icon="fa-duotone fa-hand-holding-heart"
                                class="mr-1 branded"
                            />
                            {{ $t("Step 2 — Build interest") }}
                        </strong>
                        <div class="small text-secondary">
                            {{
                                $t(
                                    "Once you're chatting, share a little about yourself. Send a teaser photo or a short video. Make them curious to see more — that's what brings them over."
                                )
                            }}
                        </div>
                    </div>
                    <div class="mb-3">
                        <strong>
                            <font-awesome-icon
                                icon="fa-duotone fa-link"
                                class="mr-1 branded"
                            />
                            {{ $t("Step 3 — Send your link") }}
                        </strong>
                        <div class="small text-secondary">
                            {{
                                $t(
                                    "When they're interested, invite them to continue chatting on Findmate. Send your invite link through WhatsApp, Telegram, or any messaging app — not directly inside dating apps."
                                )
                            }}
                        </div>
                    </div>
                    <div class="mb-3">
                        <strong>
                            <font-awesome-icon
                                icon="fa-duotone fa-coins"
                                class="mr-1 text-warning"
                            />
                            {{ $t("You earn 10% on every purchase") }}
                        </strong>
                        <div class="small text-secondary">
                            {{
                                $t(
                                    "Every time your customer buys credits, you automatically earn 10% of what they spend. You don't have to do anything — it just shows up in your wallet. The more customers you bring in, the more you earn."
                                )
                            }}
                        </div>
                    </div>
                    <div>
                        <strong>
                            <font-awesome-icon
                                icon="fa-duotone fa-lightbulb"
                                class="mr-1 text-warning"
                            />
                            {{ $t("Tip") }}
                        </strong>
                        <div class="small text-secondary">
                            {{
                                $t(
                                    "Focus on people from USA, Canada, Australia, and Europe. They are the most likely to buy credits and become long-term customers."
                                )
                            }}
                        </div>
                    </div>
                </div>
            </b-tab>
        </b-tabs>

        <b-btn
            v-if="modal"
            @click="viewInfluencer"
            variant="primary"
            pill
            block
            size="lg"
            class="mt-3"
        >
            {{ $t("Finished Reading") }}
        </b-btn>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    created() {
        this.$store.dispatch("creatorGuide/refresh");
    },
    computed: {
        ...mapState("brand", ["brand"]),
        ...mapState("creatorGuide", [
            "currentGuide",
            "guides",
            "popularApps",
            "refillCommissionPercentage",
        ]),
        modal: {
            get() {
                return this.$store.state.creatorGuide.currentGuide
                    ? true
                    : false;
            },
            set(value) {
                if (!value) {
                    this.$store.commit("creatorGuide/reset");
                }
            },
        },
        ...mapState({
            onboardingUser: (state) => state.onboarding.user,
        }),
    },
    methods: {
        viewInfluencer() {
            this.$store.commit(
                "interface/setInfluencerGuideModalVisible",
                false
            );

            this.api.post("/creatorGuide/finishedInfluencer").then(() => {
                this.$store.dispatch("onboarding/status");
                this.$store.commit("creatorGuide/reset");
                this.$store.dispatch("creatorGuide/refresh");
            });
        },
    },
    components: {},
};
</script>
